import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./banner.css";
import gameBannerBg from "../../assets/gameBannerBg.png";
import logo2xReward from "../../assets/banner/reward2x.svg";
import beeLogoUrl1 from "../../assets/banner/spellBeeBanner1.png";
import beeLogoUrl2 from "../../assets/banner/spellBeeBanner2.png";
import letterConnectLogoUrl1 from "../../assets/banner/letterConnectBanner1.png";
import letterConnectLogoUrl2 from "../../assets/banner/letterConnectBanner2.png";
import { HiMiniArrowLongRight } from "react-icons/hi2";
import { redirect, useNavigate } from "react-router-dom";
import monadLogoUrl from "../../assets/banner/monadLogo.svg";
const bannerList = [
  // {
  //   title: "Spell Bee",
  //   text: "Ready to Earn 2x Rewards",
  //   bgUrl: gameBannerBg,
  //   logoUrls: [beeLogoUrl1, beeLogoUrl2],
  //   module: "game",
  //   redirect: "/games/spell-bee",
  //   redirectText: "Play Now",
  //   newTab: false,
  //   desc: ["More Play", "More Earn"],
  //   rewardLogoUrl: logo2xReward,
  // },
  {
    title: "Roulette is Live",
    text: "Ready to Earn 36x Rewards",
    bgUrl: gameBannerBg,
    logoUrls: [],
    module: "game",
    redirect: "/games/roulette",
    redirectText: "Play Now",
    newTab: false,
    desc: ["More Play", "More Earn"],
    rewardLogoUrl: logo2xReward,
  },
  {
    title: "Letter Connect",
    text: "Coming Soon",
    module: "game",
    bgUrl: gameBannerBg,
    logoUrls: [letterConnectLogoUrl1, letterConnectLogoUrl2],
    desc: ["Connect-Earn", "Coming Soon"],
  },
  {
    title: "Monad Testnet is Live",
    text: "Go and Check",
    bgUrl: gameBannerBg,
    module: "entrypass",
    redirect: "https://blazpay.com/entrypass/monad",
    newTab: true,
    redirectText: "Buy Now",
    logoUrl: monadLogoUrl,
  },
];

const Banner = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    appendDots: (dots) => (
      <div className="">
        <ul className="flex w-fit absolute lg:right-5 right-4  lg:bottom-8 bottom-6  gap-x-1">
          {dots}
        </ul>
      </div>
    ),
    customPaging: () => (
      <div className="lg:h-[10px] h-2 lg:w-[10px] w-2 rounded-full bg-[#3C3C3C] opacity-70 transition-all duration-300"></div>
    ),
  };

  return (
    <div className="h-[64px] w-full border-2 border-[#200052] md:rounded-[20px] rounded-2xl  overflow-hidden  bg-[#000]">
      <Slider {...settings} className="w-full relative">
        {bannerList?.map((item, index) => {
          return <BannerCard key={index} details={item} />;
        })}
      </Slider>
    </div>
  );
};

export default Banner;

const BannerCard = ({ details }) => {
  const navigate = useNavigate();
  const hanldeBtnClick = (newTab, redirectUrl) => {
    if (newTab) {
      window.open(redirectUrl, "_blank");
      return;
    } else {
      navigate(redirectUrl);
    }
  };
  return (
    <div
      role="button"
      onClick={() => {
        details?.redirect && hanldeBtnClick(details?.newTab, details?.redirect);
      }}
      className="h-[60px] w-full   bg-[#000]  relative"
    >
      <div className="w-full absolute z-10 left-1/2 -translate-x-1/2 flex items-center justify-center h-full">
        <div className="flex pt-1 justify-center items-center 2xl:gap-x-16  lg:gap-x-12 md:gap-x-6 gap-x-2">
          {details?.module === "entrypass" && (
            <img
              src={details?.logoUrl}
              className="lg:scale-[1.1] md:scale-[0.80]  xs:scale-[0.86] scale-[0.60] sm:!relative absolute sm:top-0 sm:translate-y-0 top-1/2 -translate-y-1/2 sm:left-0 -left-20  lg:-ml-24 md:-ml-16 sm:-ml-24"
            />
          )}
          {details?.module === "game" && (
            <div className="flex lg:-ml-8 sm:relative absolute sm:top-0 sm:translate-y-0 top-1/2 -translate-y-1/2 sm:left-0 xs:!left-4 !-left-0 items-center">
              <img
                src={details?.rewardLogoUrl}
                className="h-fit w-fit xl:scale-[1.0]  lg:scale-[0.75] xs:scale-[0.50] scale-[0.4]"
                alt=""
              />
              {details?.rewardLogoUrl && (
                <h1
                  style={{
                    textShadow: "0 6px 4px #000",
                  }}
                  className="xl:text-3xl relative sm:left-0 -left-2 lg:text-2xl md:text-xl xs:text-[14px] text-[9px] font-akira text-[#a17933] uppercase"
                >
                  Rewards
                </h1>
              )}
              {details?.module === "game" && (
                <img
                  src={details?.logoUrls?.[0]}
                  className="mx-1 sm:!block !hidden "
                  alt=""
                />
              )}
            </div>
          )}
          <div className="flex sm:!w-fit relative sm:left-2 !w-40 sm:gap-y-0 gap-y-1 flex-col leading-[1.0] items-center">
            <h1
              style={{
                textShadow: "0 4px 4px #000",
              }}
              className="lg:!text-2xl md:!text-xl  sm:!text-base xs:!text-[13px] !text-[12px] text-center font-akira text-white"
            >
              {details?.title}
            </h1>
            <p
              style={{
                textShadow: "0 1px 2px #000",
              }}
              className="lg:text-[13px]  xs:text-[10px] text-[8px] font-bold  text-[#200052] text-center"
            >
              {details?.text}
            </p>
          </div>
          {details?.module === "game" && (
            <img
              src={details?.logoUrls?.[1]}
              className="mx-1 sm:!block !hidden "
              alt=""
            />
          )}

          {details?.redirect && (
            <div
              role="button"
              onClick={(e) => {
                e.stopPropagation();
                hanldeBtnClick(details?.newTab, details?.redirect);
              }}
              style={{
                borderStyle: "dashed",
                boxShadow: "0 0 20px rgba(255,53,03,0.4)",
              }}
              className=" lg:!w-40  !w-32  rounded-full xl:py-2 lg:py-[7px] py-1 border border-[#200052] !items-center !justify-center bg-black xs:flex hidden sm:relative absolute top-1/2 sm:top-0 sm:translate-y-0  sm:!-right-2 -translate-y-1/2 xs:!right-6 !right-3  xl:gap-x-3 lg:gap-x-2 gap-x-1 items-center justify-center"
            >
              <button className="lg:text-[10px] text-[8px] font-akira uppercase font-bold text-white bg-[#000]">
                {details?.redirectText}
              </button>
              <HiMiniArrowLongRight className="text-xl font-bold" />
            </div>
          )}
        </div>
      </div>
      <img
        src={details?.bgUrl}
        className="absolute -bottom-2 z-0 h-full w-fit lg:scale-x-[1.0] scale-[0.80] left-1/2 -translate-x-1/2"
        alt=""
      />
    </div>
  );
};
